enum ReportingCheckInStatus {
  ALL = "ALL",
  VALID_CHECKIN = "VALID_CHECKIN",
  INVALID_CHECKIN = "INVALID_CHECKIN",
  NOT_CHECKED_IN = "NOT_CHECKED_IN",
}

export default ReportingCheckInStatus;
